import { render, staticRenderFns } from "./LicenseUsageCell.vue?vue&type=template&id=aaff9794"
import script from "./LicenseUsageCell.vue?vue&type=script&lang=js"
export * from "./LicenseUsageCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports